import React from 'react'
import { Image } from '@shared/components/image'
import { Section } from '@shared/components/section'
import { ExternalPaths } from '@shared/menu-items/paths'
import AppStoreBtn from '@shared/svg/appstore.svg'
import PlayMarketBtn from '@shared/svg/googleplay.svg'
import SignOnlyLogo from '@shared/svg/sign-only-logo.svg'
import styled from 'styled-components'

export const BlockMobileApp = ({ title, items }: BlockMobileAppProps): JSX.Element => {
	return (
		<ViewRoot>
			<Section>
				<Row>
					<ColInfo>
						<ViewInfo>
							<ViewHeader>
								<TextHeader>{title}</TextHeader>
								<ImageLogo />
							</ViewHeader>
							{!!items?.length && (
								<ListItems>
									{items.map((item, idx) => (
										<Item key={idx}>{item}</Item>
									))}
								</ListItems>
							)}
							<div>
								<LinkStore target='_blank' rel='noopener noreferrer nofollow' href={ExternalPaths.appStore}>
									<AppStoreBtn />
								</LinkStore>
								<LinkStore
									target='_blank'
									rel='noopener noreferrer nofollow'
									href={ExternalPaths.playMarket}
								>
									<PlayMarketBtn />
								</LinkStore>
							</div>
						</ViewInfo>
					</ColInfo>
					<ColImage>
						<ViewImage>
							<ImageMobileApp name='mobileApp@2x.png' alt='Мобильное приложение' />
						</ViewImage>
					</ColImage>
				</Row>
			</Section>
		</ViewRoot>
	)
}

const LinkStore = styled.a({
	marginRight: 16,
	width: 180,
	height: 52,
	'& svg': {
		width: 180,
		height: 52,
	},
})

const ImageLogo = styled(SignOnlyLogo)({
	width: 62,
	height: 62,
})

const Item = styled.li(({ theme }) => ({
	...theme.typography.text20_28,
}))

const ListItems = styled.ul(({ theme }) => ({
	display: 'flex',
	flexDirection: 'column',
	gap: 20,
	[theme.mediaQueries.mediaMinWidthDesktop]: {
		gap: 10,
	},
}))

const TextHeader = styled.h2(({ theme }) => ({
	...theme.typography.header24_32,
}))

const ViewHeader = styled.div({
	display: 'flex',
	gap: 20,
})

const ImageMobileApp = styled(Image)({
	width: 'auto',
	height: 'auto',
	top: 0,
	left: 0,
	right: 0,
	bottom: 0,
	position: 'absolute',
})

const ViewImage = styled.div({
	maxHeight: '100%',
	width: '100%',
	aspectRatio: '666 / 312',
	position: 'relative',
})

const ColImage = styled.div(({ theme }) => ({
	flex: 1,
	alignSelf: 'flex-end',
	display: 'none',
	[theme.mediaQueries.mediaMinWidthTablet]: {
		display: 'block',
	},
}))

const ViewInfo = styled.div(({ theme }) => ({
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'space-between',
	gap: 20,
	backgroundColor: theme.colors.mainwhite,
	borderRadius: 16,
	boxShadow:
		'0px 18px 65px rgba(0, 0, 0, 0.07), 0px 4.02054px 6.37957px rgba(0, 0, 0, 0.0287811), 0px 1.19702px 0px rgba(0, 0, 0, 0.0082118)',
	padding: 20,
	[theme.mediaQueries.mediaMinWidthDesktop]: {
		padding: 24,
	},
}))

const ColInfo = styled.div(({ theme }) => ({
	flex: 1,
	padding: '60px 0',
	[theme.mediaQueries.mediaMinWidthTablet]: {
		padding: '40px 0',
	},
	[theme.mediaQueries.mediaMinWidthDesktop]: {
		padding: '60px 0',
	},
}))

const Row = styled.div(({ theme }) => ({
	display: 'flex',
	padding: '0',
	[theme.mediaQueries.mediaMinWidthMobile]: {
		padding: '0 90px',
	},
	[theme.mediaQueries.mediaMinWidthTablet]: {
		padding: '0',
	},
}))

const ViewRoot = styled.div(({ theme }) => ({
	backgroundColor: theme.colors.bluealice,
	[theme.mediaQueries.mediaMinWidthTablet]: {
		backgroundColor: theme.colors.lightmint,
	},
	[theme.mediaQueries.mediaMinWidthDesktop]: {
		backgroundColor: theme.colors.bluealice,
	},
}))

interface BlockMobileAppProps {
	title?: string | undefined
	items?: Array<string>
}
